<div class="w-full home-banner flex flex-column justify-content-center">
    <div class="flex flex-column justify-content-around flex-wrap w-10 m-auto">
        <h1 class="text-white text-4xl sm:text-6xl m-0">MuyComplacientes</h1>
        <h2 class="text-white">Contactos de Prepagos y Escorts en Colombia</h2>
        <div class="flex flex-row flex-wrap gap-2">
            <a *ngFor="let city of cities" [routerLink]="getCityUrl(city.searchName)" 
                class="p-button no-underline" title="Escorts {{ city.name }}">
                Escorts {{ city.name }}
            </a>
            <a [routerLink]="getUrl('registro-1')" class="p-button no-underline" title="Crear anuncio">
                Crear anuncio
            </a>
        </div>
    </div>
    <div class="w-10 mx-auto">
        <p class="text-white text-xl my-5">Descubre perfiles de Escorts y Prepagos Independientes en Colombia en MuyComplacientes. Busca, encuentra y contacta directamente con las acompañantes de tu preferencia.
        </p>
    </div>
</div>
<div class="w-10 m-auto text-justify">
    <h2>MuyComplacientes: tu nuevo sitio predilecto de Escorts y Prepagos Colombianas</h2>
    <p>
        MuyComplacientes es un nuevo portal web de anuncios de Escorts en Colombia. Todos los perfiles han sido verificados por nuestro equipo de trabajo, por lo que los usuarios interesados en contactar Prepagos en Bogotá o Prepagos en Medellín, podrán estar seguros de que la escort es la misma de las fotografías de su anuncio.
    </p>
    <p>
        La página cuenta con diferentes canales de atención al cliente, por un lado se encuentra nuestro número de teléfono y chat establecido para las anunciantes, y por otro, nuestro formulario de contacto, donde las personas podrán reportar o enviar sugerencias relacionadas con los anuncios de las Escorts publicadas.
    </p>
    <h2>¿Qué tipo de contenido puedo encontrar en MuyComplacientes?</h2>
    <p>
        Vale la pena recalcar que el contenido de MuyComplacientes es exclusivo para un público adulto, mayor de edad. Los anuncios son de Escorts, Prepagos y Putas en Colombia, quienes ofrecen sus servicios de forma independiente.
    </p>
    <p>
        MuyComplacientes ofrece un espacio publicitario para las chicas prepago y los usuarios directamente podrán contactar con ellas de forma independiente. En cada perfil se encuentran las fotos, descripción de servicios y número de contacto.
    </p>
    <p>
        En MuyComplacientes se encuentran los mejores anuncios de Prepagos en Bogotá y Medellín. Por el momento solo se encuentran habilitadas las sexo servidoras de las principales ciudades de Colombia. Sin embargo, muy pronto estaremos habilitando nuevas ubicaciones.
    </p>
    <h2>¿Por qué elegir MuyComplacientes para buscar Escorts y Prepagos en Colombia?</h2>
    <p>
        Como mencionamos anteriormente, este es un sitio web que está en lanzamiento. MuyComplacientes quiere ser el mejor y más fiable portal de anuncios Escort en el país.
    </p>
    <p>
        Cada día ingresan nuevos anuncios al portal, ya que las fotos siempre están actualizadas y el contenido siempre es reciente y va creciendo día a día, con casi un centenar de prepagos publicadas. Conoce hoy y contacta Escorts en Bogotá y Prepagos en Medellín, mira las mejores fotografías 100%  reales y disfruta de una acompañante complaciente y hermosa.
    </p>
    <img class="p-4" src="assets/images/escorts.jpg" width="100%" alt="Captura de pantalla del listado de escorts">
    <div class="flex flex-row w-full m-auto justify-content-center">
        <a [routerLink]="getUrl('lista-perfiles')" ariaLabel="Escorts y prepagos en Colombia" class="p-button no-underline m-4">
            Escorts y prepagos en Colombia
        </a>
    </div>
    <p-fieldset legend="Aliados de MuyComplacientes" styleClass="my-3" [collapsed]="true" [toggleable]="true">
        <app-allies></app-allies>
    </p-fieldset>
</div>